import React from 'react';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const TimeField = ({ value, onChange }) => {
    const pickerValue = React.useMemo(() => {
        if (!value) return null;

        const [hour, minute] = value.split(':');
        return dayjs().hour(+hour).minute(+minute);
    }, [value]);

    const handleChange = (newValue) => {
        if (!newValue || !dayjs(newValue).isValid()) {
            onChange('');
            return;
        }

        // ✅ Send 24-hour format to API
        const timeStr = newValue.format('HH:mm');
        onChange(timeStr);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
                value={pickerValue}
                onChange={handleChange}
                ampm={true}
                format="hh:mm A" // ✅ This controls UI display
                slotProps={{
                    textField: {
                        fullWidth: true,
                        placeholder: 'hh:mm AM/PM',
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default TimeField;